module.exports = __webpack_public_path__ + "static/media/accident_injury.d56f4c9a.svg";